import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { css } from "styled-components";

headerStyles.printButton = {
    buttonType: "solid",
    variant: "secondary",
}

headerStyles.addToListButton = {
    buttonType: "solid",
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
}